import { types } from "../types/types"



export const setAlert = ({
    color,
    message
}) => ({
    type: types.setAlert,
    payload: {
        color,
        message
    }
});

export const removeAlert = () => ({
    type: types.removeAlert
})